module.exports = __webpack_public_path__ + "img/dog_web_adaptive.4cb678d2.jpg";